import { Badge } from '@chakra-ui/react'

export default function NoveltyBadge() {
  return (
    <Badge colorScheme="red" width="min-content">
      Novidades
    </Badge>
  )
}
